import React from 'react';
import ProductAvailabilityCard from './Card';

type Props = {
  charts: Queries.ProductAvailabilityChartFragment[];
};

const ProductAvailabilitySection = ({ charts }: Props) => {
  return (
    <div
      sx={{
        display: 'flex',
        flexDirection: ['column', 'row'],
        justifyContent: 'center',
        alignItems: 'center',
        maxWidth: 'var(--max-width)',
        mx: 'auto',
        px: ['1.6rem', '4rem'],
        gap: ['1.6rem', '2.4rem'],
        pt: ['2.4rem', '3.2rem'],
      }}
    >
      {charts.map((chart) => (
        <ProductAvailabilityCard key={chart.title} chart={chart} />
      ))}
    </div>
  );
};

export default ProductAvailabilitySection;
